/** Indicatifs téléphoniques — essai PEP (RDC & voisins). */
export const TRIAL_DIAL_CODES = [
  { iso: "CD", label: "RDC", dial: "+243" },
  { iso: "CG", label: "Congo", dial: "+242" },
  { iso: "RW", label: "Rwanda", dial: "+250" },
  { iso: "BI", label: "Burundi", dial: "+257" },
  { iso: "AO", label: "Angola", dial: "+244" },
  { iso: "CM", label: "Cameroun", dial: "+237" },
  { iso: "UG", label: "Ouganda", dial: "+256" },
  { iso: "TZ", label: "Tanzanie", dial: "+255" },
  { iso: "FR", label: "France", dial: "+33" },
  { iso: "BE", label: "Belgique", dial: "+32" },
] as const;

export function dialCodeForIso(iso: string): string {
  const found = TRIAL_DIAL_CODES.find((c) => c.iso === iso.toUpperCase());
  return found?.dial ?? "+243";
}

export function combineTrialPhone(dialCode: string, localNumber: string): string {
  const dialDigits = dialCode.replace(/\D/g, "");
  let localDigits = localNumber.replace(/\D/g, "");
  if (!localDigits) return "";
  if (localDigits.startsWith("0")) {
    localDigits = localDigits.replace(/^0+/, "");
  }
  if (!dialDigits) return "";
  return `+${dialDigits}${localDigits}`;
}

export function normalizeTenantSlugInput(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9-]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 24);
}

export function isTenantSlugFormatValid(slug: string): boolean {
  if (!slug || slug.length < 3 || slug.length > 24) return false;
  return /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(slug);
}
